module.exports.linearFlowTypeCurveLineData = {
  tDye: [
    1.00000e-05,
    1.23285e-05,
    1.51991e-05,
    1.87382e-05,
    2.31013e-05,
    2.84804e-05,
    3.51119e-05,
    4.32876e-05,
    5.33670e-05,
    6.57933e-05,
    8.11131e-05,
    1.00000e-04,
    1.23285e-04,
    1.51991e-04,
    1.87382e-04,
    2.31013e-04,
    2.84804e-04,
    3.51119e-04,
    4.32876e-04,
    5.33670e-04,
    6.57933e-04,
    8.11131e-04,
    1.00000e-03,
    1.23285e-03,
    1.51991e-03,
    1.87382e-03,
    2.31013e-03,
    2.84804e-03,
    3.51119e-03,
    4.32876e-03,
    5.33670e-03,
    6.57933e-03,
    8.11131e-03,
    1.00000e-02,
    1.23285e-02,
    1.51991e-02,
    1.87382e-02,
    2.31013e-02,
    2.84804e-02,
    3.51119e-02,
    4.32876e-02,
    5.33670e-02,
    6.57933e-02,
    8.11131e-02,
    1.00000e-01,
    1.23285e-01,
    1.51991e-01,
    1.87382e-01,
    2.31013e-01,
    2.84804e-01,
    3.51119e-01,
    4.32876e-01,
    5.33670e-01,
    6.57933e-01,
    8.11131e-01,
    1.00000e+00,
    1.23285e+00,
    1.51991e+00,
    1.87382e+00,
    2.31013e+00,
    2.84804e+00,
    3.51119e+00,
    4.32876e+00,
    5.33670e+00,
    6.57933e+00,
    8.11131e+00,
    1.00000e+01,
    1.23285e+01,
    1.51991e+01,
    1.87382e+01,
    2.31013e+01,
    2.84804e+01,
    3.51119e+01,
    4.32876e+01,
    5.33670e+01,
    6.57933e+01,
    8.11131e+01,
    1.00000e+02,
    1.23285e+02,
    1.51991e+02,
    1.87382e+02,
    2.31013e+02,
    2.84804e+02,
    3.51119e+02,
    4.32876e+02,
    5.33670e+02,
    6.57933e+02,
    8.11131e+02,
    1.00000e+03,
    1.23285e+03,
    1.51991e+03,
    1.87382e+03,
    2.31013e+03,
    2.84804e+03,
    3.51119e+03,
    4.32876e+03,
    5.33670e+03,
    6.57933e+03,
    8.11131e+03,
    1.00000e+04,
  ],
  yexfpwdD: [
    1.27777e+02,
    1.22494e+02,
    1.16665e+02,
    1.10346e+02,
    1.03625e+02,
    9.66176e+01,
    8.94617e+01,
    8.23032e+01,
    7.52851e+01,
    6.85339e+01,
    6.21503e+01,
    5.62031e+01,
    5.07287e+01,
    4.57350e+01,
    4.12076e+01,
    3.71181e+01,
    3.34309e+01,
    3.01091e+01,
    2.71171e+01,
    2.44224e+01,
    2.19955e+01,
    1.98098e+01,
    1.78412e+01,
    1.60683e+01,
    1.44716e+01,
    1.30335e+01,
    1.17383e+01,
    1.05719e+01,
    9.52134e+00,
    8.57518e+00,
    7.72305e+00,
    6.95559e+00,
    6.26440e+00,
    5.64190e+00,
    5.08124e+00,
    4.57632e+00,
    4.12156e+00,
    3.71199e+00,
    3.34312e+00,
    3.01091e+00,
    2.71171e+00,
    2.44224e+00,
    2.19955e+00,
    1.98098e+00,
    1.78412e+00,
    1.60678e+00,
    1.44690e+00,
    1.30241e+00,
    1.17109e+00,
    1.05062e+00,
    9.38804e-01,
    8.33946e-01,
    7.35162e-01,
    6.42428e-01,
    5.56293e-01,
    4.77469e-01,
    4.06479e-01,
    3.43517e-01,
    2.88435e-01,
    2.40828e-01,
    2.00108e-01,
    1.65591e-01,
    1.36552e-01,
    1.12278e-01,
    9.20947e-02,
    7.53874e-02,
    6.16084e-02,
    5.02786e-02,
    4.09865e-02,
    3.33806e-02,
    2.71658e-02,
    2.20943e-02,
    1.79607e-02,
    1.45944e-02,
    1.18550e-02,
    9.62728e-03,
    7.81642e-03,
    6.34505e-03,
    5.14988e-03,
    4.17937e-03,
    3.39141e-03,
    2.75180e-03,
    2.23268e-03,
    1.81140e-03,
    1.46954e-03,
    1.19216e-03,
    9.67116e-04,
    7.84532e-04,
    6.36408e-04,
    5.16241e-04,
    4.18762e-04,
    3.39684e-04,
    2.75538e-04,
    2.23503e-04,
    1.81294e-04,
    1.47056e-04,
    1.19283e-04,
    9.67557e-05,
    7.84822e-05,
    6.36599e-05,
  ]
}
